import React, { useCallback, useEffect, useState } from 'react';
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { SubmitHandler, SubmitErrorHandler, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useAuth } from "../../_auth/useAuth";
import {
    IItemIdRequest,
    pafApi,
    ILicensee, licenseeApi,
    IPafApplication, IPafApplicationSignature,
    ILookupNAICS, ILookupSearchTerm, ILookupState, lookupApi,
    brokerApi,
} from "../../_api";
import { AuthRolesEnum, pafApplicationFields } from "../../_appData";
import { FormPaper } from "./Paf.styles";
import {
    ButtonBar, DaButton,
    DaAutocompleteField, DaCheckboxField, DaDatePickerField, DaHiddenField,
    DaNumberFormatField, NumberFormatType, DaSignatureField, DaTextField, DaTextField2,
    Form, FormSectionHeader, FormTitle, HTMLComment,
    IAutocompleteDialogTextProps,
    IMessagePanelProps, MessageBox, MessagePanel, MsgBoxType, ProgressPanel,
    SignatureDialog, ISignatureDialogTextProps, SignatureSourceType, SignatureTerms, BrokerAddDialog,
} from "../_shared";
import { throttle } from 'lodash';
import { Search } from "@mui/icons-material";
import { pafSchema } from './paf.schema';



// const listAdminTypeListItems = [
//     { value: 1, text: "Broker/Agent" },
//     { value: 2, text: "List Administrator" },
//     { value: 3, text: "Cooperative Database" },
// ]

export const PafApplicationView: React.FC = () => {
    const theme = useTheme();
    const { user, getAccessToken, userHasPrivilege } = useAuth();
    const navigate = useNavigate();
    const [msgPanelProps, setMsgPanelProps] = useState<IMessagePanelProps>({ message: "" });
    const [progressTitle, setProgressTitle] = useState<string>("Getting Licensee Info...");
    const [showError, setShowError] = useState<boolean>(false);
    const [showProgress, setShowProgress] = useState<boolean>(true);
    const [msgBoxOpen, setMsgBoxOpen] = React.useState<boolean>(false);
    const [msgBoxProps, setMsgBoxProps] = useState<IMessagePanelProps>({ message: "" });
    const [signatureDialogOpen, setSignatureDialogOpen] = React.useState<boolean>(false);
    const [signatureDialogProps, setSignatureDialogProps] = useState<ISignatureDialogTextProps | undefined>(undefined);
    const [stateOptions, setStateOptions] = useState<Array<ILookupState>>([]);
    const [naicsOptions, setNaicsOptions] = useState<Array<ILookupNAICS>>([]);
    const [dlgSelListAdminOpen, setDlgSelListAdminOpen] = React.useState<boolean>(false);
    const [dlgSelListAdminProps, setDlgSelListAdminProps] = useState<IAutocompleteDialogTextProps>({ title: "Choose ListAdmin" });


    const formFieldSize = "medium";
    const formFieldVariant = "standard";
    const aevMode = "add";


    // defining the initial state for the form
    const initialValues = {
        paf_id: '',
        paf_sid: '',
        company__company_name: '',
        company__parent_company_name: '',
        company__dba_name: '',
        company__address1: '',
        company__address2: '',
        company__city: '',
        company__state: '',
        company__postal_code: '',
        company__federal_tax_id: '',
        company__naics_code: '',
        company__phone: '',
        company__representative_name: '',
        company__representative_title: '',
        company__representative_email: '',
        company__is_deleted: false,
        company__is_internal: false,
        notes: '',
        is_foreign_location: false,
        is_ncoa: false,
        is_dsf: false,
        is_triplex: false,
        is_waiver_on_file: false,
        is_deleted: false,
        licensee_acct_exec: '',
        licensee_sales_office: '',
        licensee_operator: '',
        create_datetime: new Date(),
        modify_datetime: new Date(),
        licensee_id: -1,
        licensee__company_name: '',
        licensee__officer_name: '',
        licensee__officer_title: '',
        licensee__federal_tax_id: '',
        listadmin_id: -1,
        listadmin__company_name: '',
        listadmin__address1: '',
        listadmin__address2: '',
        listadmin__city: '',
        listadmin__state: '',
        listadmin__postal_code: '',
        listadmin__phone: '',
        listadmin__naics_code: '',
        licensee_signature_attest: false,
        licensee_signature_text: '',
        licensee_signature_date: null,
        list_admin_signature_attest: false,
        list_admin_signature_text: '',
        list_admin_signature_date: null,
        list_owner_signature_attest: false,
        list_owner_signature_text: '',
        list_owner_signature_date: null,
    };

    const { control, getValues, handleSubmit, reset, resetField, setValue, formState: { errors } } =
        useForm<IPafApplication>({
            defaultValues: initialValues,
            resolver: yupResolver(pafSchema)
        });

    const msgBox_Close = (value?: string) => {
        setMsgBoxOpen(false);
    }

    const msgBox_Show = (message: string, title?: string, type?: MsgBoxType) => {
        setMsgBoxProps({
            message: message,
            title: title,
            type: type,
        })
        setMsgBoxOpen(true);
    }
    const dlgSelListAdmin_Show = (title?: string) => {
        setDlgSelListAdminProps({
            title: title,
        })
        setDlgSelListAdminOpen(true);
    }

    const dlgSelListAdmin_Close = (value?: string, item_id?: number) => {
        debugger;
        setDlgSelListAdminOpen(false);

        if (value && value === "ok") {
            // Upload File
            if (item_id) {
                const options: IItemIdRequest = {
                    id: item_id as number,
                };

                // get BALA object for Selected BALA
                getListAdminData(options);
            }
        }
    }

    const onClickSelListAdmin = () => {
        // Display File Upload dialog
        dlgSelListAdmin_Show("Choose Authorized ListAdmin");
    }

    const listAdminSignatureDialog_Show = () => {
        signatureDialog_Show("listAdmin");
    }

    const setListAdminSignature = (data?: IPafApplicationSignature) => {
        setValue("list_admin_signature_attest", data?.is_attest);
        setValue("list_admin_signature_text", data?.signature_text);
        setValue("list_admin_signature_date", data?.signature_date);
    }

    const clearListAdminSignature = () => {
        resetField("list_admin_signature_attest");
        resetField("list_admin_signature_text");
        resetField("list_admin_signature_date");
    }

    const listOwnerSignatureDialog_Show = () => {
        signatureDialog_Show("listOwner");
    }

    const setListOwnerSignature = (data?: IPafApplicationSignature) => {
        setValue("list_owner_signature_attest", data?.is_attest);
        setValue("list_owner_signature_text", data?.signature_text);
        setValue("list_owner_signature_date", data?.signature_date);
    }

    const clearListOwnerSignature = () => {
        resetField("list_owner_signature_attest");
        resetField("list_owner_signature_text");
        resetField("list_owner_signature_date");
    }

    const signatureDialog_Show = (source: SignatureSourceType) => {
        const isNcoa = getValues("is_ncoa");
        const isNcoaWaiver = getValues("is_waiver_on_file");
        const isDsf2 = getValues("is_dsf");

        let includedTerms: Array<React.ReactElement> = [];
        if (isNcoa)
            includedTerms.push(SignatureTerms.ncoaLinkTerms);
        if (isNcoaWaiver)
            includedTerms.push(SignatureTerms.ncoaFulfillmentWaiverTerms);
        if (isDsf2)
            includedTerms.push(SignatureTerms.dsf2Terms);

        includedTerms.push(SignatureTerms.signatureDisclaimer);

        let terms: React.ReactElement = React.createElement(React.Fragment, undefined, includedTerms);
        setSignatureDialogProps({
            source: source,
            title: "USPS Processing Acknowledgement Form e-Signature",
            terms: terms,
        })
        setSignatureDialogOpen(true);
    }

    const signatureDialog_Close = (source: SignatureSourceType, action: string, data?: IPafApplicationSignature) => {
        if (source === "listOwner") {
            if (action === "submit") {
                // Set values on PAFApplication object prior to saving
                setListOwnerSignature(data);
            } else {
                clearListOwnerSignature();
            }
        }
        if (source === "listAdmin") {
            if (action === "submit") {
                // Set values on PAFApplication object prior to saving
                setListAdminSignature(data);
            } else {
                clearListAdminSignature();
            }
        }
        setSignatureDialogOpen(false);
    }

    const onSubmit: SubmitHandler<IPafApplication> = (data) => {
        savePafData(data);
    };

    const onSubmitErrors: SubmitErrorHandler<IPafApplication> = (errors) => {
        let errText: string = "";
        let key: keyof typeof errors;
        for (key in errors) {
            errText += `- ${errors[key]?.message}\n`;
        }
        msgBox_Show(
            `An error occurred while attempting to save PAF Application...\n${errText}`,
            "Invalid PAF Application...",
            "error"
        );
    };

    const showErrorPanel = ({ title, message, type = "error" }: IMessagePanelProps) => {
        const msgProps: IMessagePanelProps = {
            message: message,
            title: title,
            type: type
        }
        setMsgPanelProps(msgProps);
        setShowError(true);
    }

    const savePafData = useCallback(async (options): Promise<void> => {
        setProgressTitle("Saving PAF Application...");
        setShowProgress(true);

        const auth_token = await getAccessToken();
        let apiPromise = undefined;
        if (aevMode === "add") {
            apiPromise = pafApi.add(options, auth_token);
        } else {
            showErrorPanel({
                title: "Inconsistent Form State Error",
                message: "An error occurred while saving PAF Application. " +
                    "Navigate to the PAF list view and retry your last action."
            });
            setShowProgress(false);
        }

        apiPromise && apiPromise.then((resp) => {
            if (resp && resp.success) {
                navigate("/pafs");
            } else {
                showErrorPanel({
                    title: "Unable to Save PAF Application",
                    message: "An error occurred while saving PAF Application. " +
                        "Verify that you have provided all required data and " +
                        "retry your last action."
                });
            }
        })
            .catch(() => {
                showErrorPanel({
                    title: "PAF API Save Error",
                    message: "An error occurred while saving PAF Application. " +
                        "There may have been a network error.",
                });
            })
            .finally(() => {
                setShowProgress(false);
            });
    }, []);

    // Lookup Field methods
    const stateSearch = React.useRef(
        throttle(async (search_term) => {
            const term = typeof search_term === 'string' ? search_term : '';
            if (term.length < 2) {
                setStateOptions([]);
            } else {
                setStateOptions(await getStateOptions(term) as Array<ILookupState>);
            }
        }, 250)
    ).current;

    const stateInputChanged = async (e: React.SyntheticEvent, newValue: string, reason: string): Promise<void> => {
        // Don't re-run search for
        // programmatic change, user selection
        if (reason !== "reset") {
            stateSearch(typeof newValue === 'string' ? newValue : '');
        }
    }

    const getStateOptions = async (search_term: string): Promise<Array<ILookupState> | void> => {
        const options: ILookupSearchTerm = { search_term: search_term };
        const auth_token = await getAccessToken();
        try {
            const resp = await lookupApi.get_state_lookup(options, auth_token);
            if (resp) {
                if (resp.success) {
                    return resp.data;
                } else if (resp.error && resp.error.length > 0) {
                    showErrorPanel({
                        title: "State lookups Not Found Error",
                        message: "An error occurred while retrieving State lookups data. " +
                            "The State lookups data was not found.",
                    });
                }
            }
        }
        catch (err) {
            showErrorPanel({
                title: "Lookup API Fetch Error",
                message: "An error occurred while fetching State lookups data. " +
                    "There may have been a network error.",
            });
        }
    };

    const naicsSearch = React.useRef(
        throttle(async (search_term) => {
            const term = typeof search_term === 'string' ? search_term : '';
            if (term.length < 3) {
                setNaicsOptions([]);
            } else {
                setNaicsOptions(await getNaicsOptions(term) as Array<ILookupNAICS>);
            }
        }, 250)
    ).current;

    const naicsInputChanged = async (e: React.SyntheticEvent, newValue: string, reason: string): Promise<void> => {
        // Don't re-run search for
        // programmatic change, user selection
        if (reason !== "reset") {
            naicsSearch(typeof newValue === 'string' ? newValue : '');
        }
    }

    const getNaicsOptions = async (search_term: string): Promise<Array<ILookupNAICS> | void> => {
        const options: ILookupSearchTerm = { search_term: search_term };
        const auth_token = await getAccessToken();
        try {
            const resp = await lookupApi.get_naics_lookup(options, auth_token);
            if (resp) {
                if (resp.success) {
                    return resp.data;
                } else if (resp.error && resp.error.length > 0) {
                    showErrorPanel({
                        title: "NAICS lookups Not Found Error",
                        message: "An error occurred while retrieving NAICS lookups data. " +
                            "The NAICS lookups data was not found.",
                    });
                }
            }
        }
        catch (err) {
            showErrorPanel({
                title: "Lookup API Fetch Error",
                message: "An error occurred while fetching NAICS lookups data. " +
                    "There may have been a network error.",
            });
        }
    };

    const getListAdminData = useCallback(async (options: IItemIdRequest): Promise<void> => {
        const auth_token = await getAccessToken();

        brokerApi.get_by_id(options, auth_token)
            .then((resp) => {
                if (resp && resp.success && resp.data) {
                    const broker = resp.data;
                    const company = broker.company || {};
                    // Map company fields to listadmin__* fields
                    setValue("listadmin_id", broker.listadmin_id);
                    setValue("listadmin__listadmin_sid", broker.listadmin_sid);
                    setValue("listadmin__company_name", company.company_name || '');
                    setValue("listadmin__address1", company.address1 || '');
                    setValue("listadmin__address2", company.address2 || '');
                    setValue("listadmin__city", company.city || '');
                    setValue("listadmin__state", company.state || '');
                    setValue("listadmin__postal_code", company.postal_code || '');
                    setValue("listadmin__naics_code", company.naics_code || '');
                    setValue("listadmin__phone", company.phone || '');
                    setValue("listadmin__representative_name", company.representative_name || '');
                    setValue("listadmin__representative_title", company.representative_title || '');
                    setValue("listadmin__representative_email", company.representative_email || '');
                } else if (resp && resp.error && resp.error.length > 0) {
                    showErrorPanel({
                        title: "Broker Not Found Error",
                        message: "An error occurred while retrieving Broker data. The Broker data was not found.",
                    });
                }
            })
            .catch(() => {
                showErrorPanel({
                    title: "Broker API Fetch Error",
                    message: "An error occurred while fetching Broker data. There may have been a network error.",
                });
            });

    }, []);

    const defaultLicenseeId = 1;
    const getLicenseeData = useCallback(async (): Promise<void> => {
        const auth_token = await getAccessToken();

        let licensee: ILicensee = {
            "licensee_id": -1,
            "company_name": "",
            "officer_name": "",
            "officer_title": "",
            "phone": "",
            "fax": "",
            "federal_tax_id": "",
        }
        licenseeApi.get_licensee_details(auth_token)
            .then((resp) => {
                if (resp) {
                    if (resp.success) {
                        if (resp.data) {
                            licensee = resp.data;
                        }
                    } else if (resp.error && resp.error.length > 0) {
                        showErrorPanel({
                            title: "Licensee Not Found Error",
                            message: "An error occurred while retrieving Licensee data. " +
                                "The Licensee data was not found.",
                        });
                    }
                }
            })
            .catch(() => {
                showErrorPanel({
                    title: "Licensee API Fetch Error",
                    message: "An error occurred while fetching Licensee data. " +
                        "There may have been a network error.",
                });
            })
            .finally(() => {
                // Update Licensee data on PAF record
                setValue("licensee_id", licensee.licensee_id);
                setValue("licensee__company_name", licensee.company_name);
                setValue("licensee__officer_name", licensee.officer_name);
                setValue("licensee__officer_title", licensee.officer_title);
                setValue("licensee__federal_tax_id", licensee.federal_tax_id);
            });

    }, [defaultLicenseeId]);

    const getPafData = useCallback(async (): Promise<void> => {
        setProgressTitle("Getting PAF Application Data...");
        setShowProgress(true);

        if (aevMode === "add") {
            // Get Licensee Info
            await getLicenseeData();

            setShowProgress(false);
        }

    }, [reset, aevMode]);

    useEffect(() => {
        // Get data from remote service
        const resp = getPafData();

        return () => {
            naicsSearch.cancel();
            stateSearch.cancel();
        };

    }, [getPafData, naicsSearch, stateSearch]);

    return (
        <>
            <FormPaper elevation={4}>
                {/* Form Title*/}
                <FormTitle
                    title={"USPS: Processing Acknowledgment Form"}
                    titleIcon={"assignment_rounded_icon"}
                />

                <Grid container>
                    {showProgress ? (
                        <Grid container justifyContent={"center"} item>
                            <ProgressPanel title={progressTitle} />
                        </Grid>
                    ) : (showError ? (
                        <Grid container justifyContent={"center"} item>
                            <MessagePanel
                                {...msgPanelProps}
                            />
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <Form
                                autoComplete="off"
                                onSubmit={handleSubmit(onSubmit, onSubmitErrors)}
                            >
                                <Box sx={{ minHeight: theme.spacing(73) }}>
                                    {/* Paf Info Tab */}
                                    <Grid container spacing={theme.spacing(1)}>
                                        {/* List Owner Section Header */}
                                        <Grid item xs={12} md={12}>
                                            <FormSectionHeader
                                                title={"List Owner"}
                                                typeVariant={"h5"}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.companyName.name}
                                                label={pafApplicationFields.companyName.label}
                                                required={pafApplicationFields.companyName.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.address1.name}
                                                label={pafApplicationFields.address1.label}
                                                required={pafApplicationFields.address1.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.address2.name}
                                                label={pafApplicationFields.address2.label}
                                                required={pafApplicationFields.address2.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.city.name}
                                                label={pafApplicationFields.city.label}
                                                required={pafApplicationFields.city.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaAutocompleteField
                                                control={control}
                                                name={pafApplicationFields.state.name}
                                                label={pafApplicationFields.state.label}
                                                required={pafApplicationFields.state.required}
                                                options={stateOptions.map(
                                                    ({ state_code, state_name, country_code }) =>
                                                        ({ value: state_code, label: `${state_code} - ${state_name} (${country_code})` })
                                                )}
                                                onInputChange={stateInputChanged}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.postalCode.name}
                                                label={pafApplicationFields.postalCode.label}
                                                required={pafApplicationFields.postalCode.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.urbanization.name}
                                                label={pafApplicationFields.urbanization.label}
                                                required={pafApplicationFields.urbanization.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaNumberFormatField
                                                control={control}
                                                name={pafApplicationFields.phone.name}
                                                label={pafApplicationFields.phone.label}
                                                required={pafApplicationFields.phone.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                                numberFormat={NumberFormatType.US_Phone}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <HTMLComment text={"Placeholder"} />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaAutocompleteField
                                                control={control}
                                                name={pafApplicationFields.naicsCode.name}
                                                label={pafApplicationFields.naicsCode.label}
                                                required={pafApplicationFields.naicsCode.required}
                                                options={naicsOptions.map(({ naics_code, naics_title }) =>
                                                    ({ value: naics_code, label: `${naics_code} - ${naics_title}` })
                                                )}
                                                onInputChange={naicsInputChanged}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaNumberFormatField
                                                control={control}
                                                name={pafApplicationFields.uspsMailerId.name}
                                                label={pafApplicationFields.uspsMailerId.label}
                                                required={pafApplicationFields.uspsMailerId.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                                numberFormat={NumberFormatType.MAILER_ID}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaNumberFormatField
                                                control={control}
                                                name={pafApplicationFields.customerRegistrationId.name}
                                                label={pafApplicationFields.customerRegistrationId.label}
                                                required={pafApplicationFields.customerRegistrationId.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                                numberFormat={NumberFormatType.CR_ID}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.parentCompanyName.name}
                                                label={pafApplicationFields.parentCompanyName.label}
                                                required={pafApplicationFields.parentCompanyName.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.dbaName.name}
                                                label={pafApplicationFields.dbaName.label}
                                                required={pafApplicationFields.dbaName.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.representativeName.name}
                                                label={pafApplicationFields.representativeName.label}
                                                required={pafApplicationFields.representativeName.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.representativeTitle.name}
                                                label={pafApplicationFields.representativeTitle.label}
                                                required={pafApplicationFields.representativeTitle.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.representativeEmail.name}
                                                label={pafApplicationFields.representativeEmail.label}
                                                required={pafApplicationFields.representativeEmail.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.companyWebsite.name}
                                                label={pafApplicationFields.companyWebsite.label}
                                                required={pafApplicationFields.companyWebsite.required}
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaCheckboxField
                                                control={control}
                                                name={pafApplicationFields.isNcoa.name}
                                                label={<>NCOA<sup>Link</sup> Service</>}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaCheckboxField
                                                control={control}
                                                name={pafApplicationFields.isDsf.name}
                                                label={<>DSF<sup>2</sup> Service</>}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaCheckboxField
                                                control={control}
                                                name={pafApplicationFields.isWaiverOnFile.name}
                                                label={<>Waive NCOA<sup>Link</sup> 7-Day Fulfillment</>}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaSignatureField
                                                control={control}
                                                name={pafApplicationFields.listOwnerSignatureText.name}
                                                label={pafApplicationFields.listOwnerSignatureText.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaDatePickerField
                                                control={control}
                                                name={pafApplicationFields.listOwnerSignatureDate.name}
                                                label={pafApplicationFields.listOwnerSignatureDate.label}
                                                readOnly
                                                disableOpenPicker
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaHiddenField
                                                control={control}
                                                name={pafApplicationFields.listOwnerSignatureAttest.name}
                                                errors={errors}
                                            />
                                        </Grid>
                                    </Grid>
                                    {(userHasPrivilege([AuthRolesEnum.ListOwner])) && (
                                        <Grid container spacing={theme.spacing(1)}>
                                            <Grid item xs={12} md={12}>
                                                <ButtonBar buttonAlignment="alignLeft">
                                                    <DaButton buttonStyle="primary" onClick={() => { listOwnerSignatureDialog_Show() }}>
                                                        e-Sign Paf
                                                    </DaButton>
                                                    <DaButton buttonStyle="secondary" onClick={() => { clearListOwnerSignature() }}>
                                                        Clear e-Signature
                                                    </DaButton>
                                                </ButtonBar>
                                            </Grid>
                                        </Grid>
                                    )}
                                    {/* List Admin Tab */}
                                    <Grid container spacing={theme.spacing(1)}>
                                        <Grid item xs={12} md={12}>
                                            <FormSectionHeader
                                                title={"Broker / Agent"}
                                                typeVariant={"h5"}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaHiddenField
                                                control={control}
                                                name={pafApplicationFields.listAdminId.name}
                                                errors={errors}
                                            />
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminSid.name}
                                                label={pafApplicationFields.listAdminSid.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            {(aevMode == "add") && (userHasPrivilege([AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin])) ? (
                                                <DaButton
                                                    buttonStyle="primary"
                                                    startIcon={<Search />}
                                                    onClick={() => { onClickSelListAdmin() }}
                                                >Select Broker</DaButton>
                                            ) : (
                                                <HTMLComment text={"Placeholder"} />
                                            )}
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <HTMLComment text={"Placeholder"} />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminCompanyName.name}
                                                label={pafApplicationFields.listAdminCompanyName.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminAddress1.name}
                                                label={pafApplicationFields.listAdminAddress1.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminAddress2.name}
                                                label={pafApplicationFields.listAdminAddress2.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminCity.name}
                                                label={pafApplicationFields.listAdminCity.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminState.name}
                                                label={pafApplicationFields.listAdminState.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminPostalCode.name}
                                                label={pafApplicationFields.listAdminPostalCode.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminPhone.name}
                                                label={pafApplicationFields.listAdminPhone.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.listAdminNaicsCode.name}
                                                label={pafApplicationFields.listAdminNaicsCode.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <HTMLComment text={"Placeholder"} />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaSignatureField
                                                control={control}
                                                name={pafApplicationFields.listAdminSignatureText.name}
                                                label={pafApplicationFields.listAdminSignatureText.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaDatePickerField
                                                control={control}
                                                name={pafApplicationFields.listAdminSignatureDate.name}
                                                label={pafApplicationFields.listAdminSignatureDate.label}
                                                readOnly
                                                disableOpenPicker
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaHiddenField
                                                control={control}
                                                name={pafApplicationFields.listAdminSignatureAttest.name}
                                                errors={errors}
                                            />
                                        </Grid>
                                    </Grid>
                                    {(userHasPrivilege([AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin])) && (
                                        <Grid container spacing={theme.spacing(1)}>
                                            <Grid item xs={12} md={12}>
                                                <ButtonBar buttonAlignment="alignLeft">
                                                    <DaButton buttonStyle="primary" onClick={() => { listAdminSignatureDialog_Show() }}>
                                                        e-Sign Paf
                                                    </DaButton>
                                                    <DaButton buttonStyle="secondary" onClick={() => { clearListAdminSignature() }}>
                                                        Clear e-Signature
                                                    </DaButton>
                                                </ButtonBar>
                                            </Grid>
                                        </Grid>
                                    )}
                                    {/* Licensee Tab */}
                                    <Grid container spacing={theme.spacing(1)}>
                                        <Grid item xs={12} md={12}>
                                            <FormSectionHeader
                                                title={"Licensee"}
                                                typeVariant={"h5"}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaHiddenField
                                                control={control}
                                                name={pafApplicationFields.licenseeId.name}
                                                errors={errors}
                                            />
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.licenseeCompanyName.name}
                                                label={pafApplicationFields.licenseeCompanyName.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.licenseeOfficerName.name}
                                                label={pafApplicationFields.licenseeOfficerName.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DaTextField
                                                control={control}
                                                name={pafApplicationFields.licenseeOfficerTitle.name}
                                                label={pafApplicationFields.licenseeOfficerTitle.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <DaNumberFormatField
                                                control={control}
                                                name={pafApplicationFields.licenseeFederalTaxId.name}
                                                label={pafApplicationFields.licenseeFederalTaxId.label}
                                                readOnly
                                                variant={formFieldVariant}
                                                size={formFieldSize}
                                                errors={errors}
                                                numberFormat={NumberFormatType.EIN}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Grid container spacing={theme.spacing(1)}>
                                    <Grid item xs={12} md={12}>
                                        <ButtonBar buttonAlignment="alignRight">
                                            <DaButton buttonStyle="secondary" onClick={() => { navigate("/pafs") }}>
                                                Back to List
                                            </DaButton>
                                            {(userHasPrivilege([AuthRolesEnum.SystemAdmin, AuthRolesEnum.BrokerAgent,
                                            AuthRolesEnum.ListAdmin, AuthRolesEnum.ListOwner, AuthRolesEnum.PafAdmin])) && (
                                                    <DaButton buttonStyle="primary" type="submit">
                                                        Save PAF
                                                    </DaButton>
                                                )}
                                        </ButtonBar>
                                    </Grid>
                                </Grid>
                            </Form>
                        </Grid>
                    ))}
                </Grid>
            </FormPaper>
            <MessageBox
                isOpen={msgBoxOpen}
                onClose={msgBox_Close}
                {...msgBoxProps}
            />
            <SignatureDialog
                isOpen={signatureDialogOpen}
                onClose={signatureDialog_Close}
                {...signatureDialogProps}
            />
            <BrokerAddDialog
                isOpen={dlgSelListAdminOpen}
                onClose={dlgSelListAdmin_Close}
                userId={user.id}
                {...dlgSelListAdminProps}
            />
        </>
    );
}